import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import imgFallback from 'src/utils/image';
import * as styles from './TwoColWithImage.module.scss';

export const TwoColWithImage = ({ header, descriptions, image }) => (
  <Container as="section" className={`${styles.container} py-6`}>
    <PortableHeader content={header} className="mb-8" />

    <div className={`${styles.descriptions} mb-6`}>
      {descriptions.map(({ _key, description }) => (
        <div key={_key} className={styles.description}>
          <PortableText value={description} />
        </div>
      ))}
    </div>

    <GatsbyImage className="mb-3" alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />
  </Container>
);

TwoColWithImage.propTypes = {
  header: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  descriptions: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    })
  ).isRequired,
  image: PropTypes.shape({}),
};

TwoColWithImage.defaultProps = {
  image: null,
};
